export default "__VITE_ASSET__DstBefyO__"